export const SET_COUNTS = 'set_counts';

export const SET_TOPICS = 'set_topics';
export const SET_TOPICS_FILTER_QUERY = 'set_topics_filter_query';
export const SET_TOPICS_FILTER_TYPE = 'set_topics_filter_type';
export const SET_TOPICS_FILTER_STATUS = 'set_topics_filter_status';
export const SET_TOPIC = 'set_topic';
export const SET_ALL_TOPIC_WEIGHTS = 'set_all_topic_weights';

export const SET_FEEDS = 'set_feeds';
export const SET_FEEDS_FILTER_QUERY = 'set_feeds_filter_query';
export const SET_FEEDS_FILTER_TYPE = 'set_feeds_filter_type';
export const SET_FEEDS_FILTER_STATUS = 'set_feeds_filter_status';
export const SET_FEED = 'set_feed';
export const SET_FEED_FIXTURES = 'set_feed_fixtures';
export const SET_FEED_ARTICLES = 'set_feed_articles';
export const SET_FEED_ARTICLES_PAGE = 'set_feed_articles_page';
export const SET_FEED_ARTICLES_QUERY = 'set_feed_articles_query';
export const SET_FEED_VIDEOS = 'set_feed_videos';
export const SET_FEED_VIDEOS_PAGE = 'set_feed_videos_page';
export const SET_FEED_VIDEOS_QUERY = 'set_feed_videos_query';
export const SET_FEED_LOGS = 'set_feed_logs';

export const SET_FIXTURE = 'set_fixture';

export const SET_ARTICLES = 'set_articles';
export const SET_ARTICLES_PAGE = 'set_articles_page';
export const SET_ARTICLES_QUERY = 'set_articles_query';
export const SET_ARTICLE = 'set_article';
export const SET_ARTICLE_VISIBLE = 'set_article_visible';

export const SET_VIDEOS = 'set_videos';
export const SET_VIDEOS_PAGE = 'set_videos_page';
export const SET_VIDEOS_QUERY = 'set_videos_query';
export const SET_VIDEO = 'set_video';
export const SET_VIDEO_VISIBLE = 'set_video_visible';

export const SET_EXPLORER_DATA = 'set_explorer_data';

export const SET_HISTORY_DATA = 'set_history_data';

export const SET_PAGES = 'set_pages';
export const SET_PAGE = 'set_page';

export const SET_WEIGHTS = 'set_weights';